<template>
  <div>

    <div class="container mt-3">
      <h2 class="text-center my-4" ref="tituloDashboard">Dashboard de Egresos</h2>
      <p class="text-center mb-4">Registra y consulta todos los egresos de tu negocio.</p>

      <div class="text-center mb-4">
        <button class="btn btn-primary btn-lg" @click="mostrarModal = true">
          <i class="bi bi-plus-circle"></i> Registrar Egreso
        </button>
      </div>

      <!-- MODAL -->
      <div v-if="mostrarModal" class="modal-backdrop">
        <div class="modal-card">
          <div class="modal-header">
            <h4>Registrar Egreso</h4>
            <button class="close" @click="mostrarModal = false">&times;</button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="confirmarRegistro">
              <div class="row mb-4">
                <div class="col">
                  <label class="h5">Monto</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">$</span>
                    </div>
                    <input
                      type="text"
                      v-model="monto"
                      required
                      class="form-control monto-input"
                      placeholder="0.00"
                      @input="formatearMonto"
                    />
                  </div>
                </div>

                <div class="col">
                  <label class="h5">Método de Pago</label>
                  <select v-model="metodoPago" required class="form-control modern-select">
                    <option value="" disabled>Seleccione</option>
                    <option value="efectivo">Efectivo</option>
                    <option value="transferencia">Transferencia</option>
                    <option value="tarjeta">Tarjeta</option>
                  </select>
                </div>

                <div class="col">
                  <label class="h5">Concepto</label>
                  <select v-model="concepto" required class="form-control modern-select">
                    <option value="" disabled>Seleccione</option>
                    <option value="renta_vestidos">Sueldo</option>
                    <option value="Comision-renta">Comisión renta</option>
                    <option value="Comision-Ajustes">Comisión Ajustes</option>
                    <option value="renta-local">Renta local</option>
                    <option value="luz">Luz - CFE'</option>
                    <option value="agua">Agua - Comapa'</option>
                    <option value="internet">Internet</option>
                    <option value="Lavado">Lavado</option>
                    <option value="Vestidos">Compra Vestidos</option>
                    <option value="Inmobiliario">Compra Inmobiliario</option>
                    <option value="Papeleria">Compra Papelería</option>
                    <option value="Publicidad">Publicidad</option>
                    <option value="Otros">Otros gastos</option>
                  </select>
                </div>
              </div>

              <div v-if="concepto === 'Otros'" class="mb-4">
                <label>Especifique el gasto:</label>
                <input
                  type="text"
                  v-model="detalleOtrosGastos"
                  class="form-control"
                  placeholder="Describa el gasto"
                  required
                />
              </div>

              <div class="form-group mb-4">
                <label class="h5">Fecha</label>
                <input type="date" v-model="fecha" required class="form-control" />
              </div>

              <button type="submit" class="btn btn-primary btn-lg w-100">
                <i class="bi bi-arrow-up-circle"></i> Registrar Egreso
              </button>
            </form>
          </div>
        </div>
      </div>

      <!-- DASHBOARD -->
      <div class="dashboard">
        <div class="text-center mb-4">
          <h3>Total de Egresos:
            <span class="egreso-color">
              {{ totalEgresos > 0 ? totalEgresos.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) : '$0.00' }}
            </span>
          </h3>
        </div>

        <div class="row mb-3">
          <div class="col-md-4">
            <label class="h5">Filtrar por Concepto</label>
            <select v-model="filtroConcepto" class="form-control modern-select">
              <option value="">Todos</option>
              <option value="renta_vestidos">Sueldo</option>
                    <option value="Comision-renta">Comisión renta</option>
                    <option value="Comision-Ajustes">Comisión Ajustes</option>
                    <option value="Comision-local">Renta local</option>
                    <option value="luz">Luz - CFE'</option>
                    <option value="agua">Agua - Comapa'</option>
                    <option value="internet">Internet</option>
                    <option value="Lavado">Lavado</option>
                    <option value="Vestidos">Compra Vestidos</option>
                    <option value="Inmobiliario">Compra Inmobiliario</option>
                    <option value="Papeleria">Compra Papelería</option>
                    <option value="Publicidad">Publicidad</option>
                    <option value="Otros">Otros gastos</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="h5">Filtrar por Fecha</label>
            <input type="date" v-model="filtroFecha" class="form-control" />
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-bordered table-striped table-sm text-center">
            <thead class="thead-dark">
              <tr>
                <th>ID</th>
                <th>Monto</th>
                <th>Método de Pago</th>
                <th>Concepto</th>
                <th>Fecha</th>
                <th>Registró</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(egreso, index) in egresosFiltrados" :key="index">
                <td :data-label="'ID'">{{ egreso.id }}</td>
                <td :data-label="'Monto'">${{ parseFloat(egreso.monto).toFixed(2) }}</td>
                <td :data-label="'Método de Pago'">{{ egreso.metodo_de_pago }}</td>
                <td :data-label="'Concepto'">{{ egreso.concepto }}</td>
                <td :data-label="'Fecha'">{{ formatFecha(egreso.fecha) }}</td>
                <td :data-label="'Registró'">{{ egreso.nombre_usuario }}</td>
              </tr>
              <tr v-if="egresosFiltrados.length === 0">
                <td colspan="6" class="text-center">No hay egresos registrados</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";
import baseUrl from "../api";
import axios from "axios";
import moment from "moment-timezone";
import gsap from "gsap";

export default {
  name: "Egresos-vue",
  data() {
    const zona = moment.tz.guess();

    return {
      monto: "",
      metodoPago: "",
      concepto: "",
      egresos: [],
      filtroConcepto: "",
fecha: moment().tz(zona).format("YYYY-MM-DD"),
filtroFecha: moment().tz(zona).format("YYYY-MM-DD"),

      detalleOtrosGastos: "",
      mostrarModal: false,
    };
  },
  computed: {
    ...mapState(["id_usuario"]),
    egresosFiltrados() {
      return this.egresos.filter((e) => {
        const fechaCoincide = this.filtroFecha ? e.fecha?.split("T")[0] === this.filtroFecha : true;
        const conceptoCoincide = this.filtroConcepto ? e.concepto === this.filtroConcepto : true;
        return fechaCoincide && conceptoCoincide;
      });
    },
    totalEgresos() {
      return this.egresosFiltrados.reduce((total, e) => {
        const monto = parseFloat(e.monto);
        return total + (isNaN(monto) ? 0 : monto);
      }, 0);
    },
  },
  methods: {

    formatFecha(fechaISO) {
  if (!fechaISO) return "Sin fecha";
  const fecha = new Date(fechaISO);
  const dia = String(fecha.getDate()).padStart(2, '0');
  const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Meses van de 0 a 11
  const año = fecha.getFullYear();
  return `${dia}/${mes}/${año}`;
}
,
    formatearMonto() {
      let value = this.monto.replace(/\D/g, "");
      if (value) {
        this.monto = (parseFloat(value) / 100).toFixed(2);
      }
    },
    async confirmarRegistro() {
      if (!this.monto || !this.metodoPago || !this.concepto || !this.fecha) {
        Swal.fire({ icon: "error", title: "Campos incompletos", text: "Complete todos los campos." });
        return;
      }

      const resultado = await Swal.fire({
        title: "¿Está seguro de registrar este egreso?",
        html: `
          Monto: $${this.monto}<br/>
          Método de Pago: ${this.metodoPago}<br/>
          Concepto: ${this.concepto}<br/>
          Fecha: ${this.fecha}<br/>
        `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, registrar",
        cancelButtonText: "Cancelar",
      });

      if (resultado.isConfirmed) {
        this.registrarEgreso(parseFloat(this.monto));
      }
    },
    async registrarEgreso(montoFinal) {
      const egreso = {
        monto: montoFinal,
        metodo_de_pago: this.metodoPago,
        concepto: this.concepto,
        fecha: this.fecha,
        id_usuario: this.id_usuario,
      };

      try {
        const response = await axios.post(`${baseUrl}/api/registrar-egresos`, egreso);
        if ([200, 201].includes(response.status)) {
          Swal.fire({ icon: "success", title: "Egreso registrado", text: "El egreso fue registrado correctamente." });
          this.mostrarModal = false;
          this.limpiarFormulario();
          this.obtenerEgresos();
        }
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo registrar el egreso." });
      }
    },
    limpiarFormulario() {
      this.monto = "";
      this.metodoPago = "";
      this.concepto = "";
      const zona = moment.tz.guess();
this.fecha = moment().tz(zona).format("YYYY-MM-DD");
    },
    async obtenerEgresos() {
      try {
        const response = await axios.get(`${baseUrl}/api/egresos`);
        this.egresos = response.data;
      } catch (error) {
        console.error("Error al obtener egresos:", error);
      }
    },
  },
  mounted() {
    this.obtenerEgresos();
    gsap.from(this.$refs.tituloDashboard, {
      y: -50,
      opacity: 0,
      duration: 1,
      ease: "power2.out",
    });
  },
};
</script>


<style scoped>

.egreso-color {
  color: #bb79a9;
  font-size: 2rem;
  font-weight: bold;
  text-shadow: 1px 1px 6px rgba(0, 0, 0, 0.1);
}

.container-fluid {
  padding: 0;
  margin-top: -90px;

}

.card {
  border-radius: 12px;
  width: 100%;
  max-width: 650px; /* antes: 420px */
  margin: 0 auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.card-body {
  padding: 5px;
}

/* Título principal */
h2 {
  font-size: 28px;
  color: #333;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}

/* Descripción */
p {
  font-size: 0.95rem;
  font-style: normal;
  color: #7f8c8d;
  margin-bottom: 20px;
  text-align: center;
}

/* Formulario */
.form-group {
  margin-bottom: 15px;
}

label {
  font-weight: 500;
  font-size: 0.95rem;
  margin-bottom: 4px;
  display: inline-block;
}

input,
select {
  font-size: 0.95rem;
  padding: 8px 12px;
  border-radius: 8px;
}

input[type="date"] {
  padding: 8px 12px;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 800px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header .close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

/* Input de monto */
.input-group-text {
  font-size: 1.1rem;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border: 1px solid #ced4da;
}

.monto-input {
  font-size: 1.1rem;
  padding: 8px;
  text-align: center;
}

/* Select moderno */
.modern-select {
  background-color: #f4f6f7;
  border-radius: 6px;
  padding: 8px;
  border: 1px solid #ced4da;
}

/* Botón */
.btn {
  font-size: 1rem;
  padding: 12px;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  border-radius: 8px;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #004085;
}

/* Estilo de tabla */
.dashboard {
  margin-top: 40px;
}

.ingreso-color {
  color: #bb79a9;
  font-size: 2rem;
  font-weight: bold;
  text-shadow: 1px 1px 6px rgba(0, 0, 0, 0.1);
}

.table thead th {
  text-align: center;
}

.table td,
.table th {
  vertical-align: middle;
  font-size: 0.9rem;
}

.table-responsive {
  margin-top: 20px;
}





.table-responsive {
  overflow-x: auto;
}

@media (max-width: 768px) {
  .table {
    border: 0;
    font-size: 0.9rem;
  }

  .table thead {
    display: none;
  }

  .table tr {
    display: block;
    margin-bottom: 1rem;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: #fff;
    padding: 10px;
  }

  .table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 10px;
    border: none;
    border-bottom: 1px solid #eee;
  }

  .table td:last-child {
    border-bottom: none;
  }

  .table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #6c757d;
    flex-basis: 50%;
    text-align: left;
  }
}
</style>
